import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-788179b1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "favor-popup-box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "您已看好此项目", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "success-img",
  src: "https://p6.moimg.net/mdwxapp/project_favor_icon.png"
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "words"
}, "项目看好成功，欢迎下载[摩点APP]获取最实时的项目动态。", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "确定取消看好", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "words"
}, "取消后将收不到众筹开始提示", -1));
const _hoisted_7 = {
  class: "btn-two"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "已取消看好", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "words"
}, "系统将不会为您推送此项目的众筹开始等消息", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    show: $options.showPopup,
    "onUpdate:show": _cache[4] || (_cache[4] = $event => $options.showPopup = $event),
    round: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [$props.type == 'success' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_hoisted_2, _hoisted_3, _hoisted_4, _createElementVNode("strong", {
      class: "btn",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.close && $options.close(...args))
    }, "知道了")], 64)) : $props.type == 'cancel' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_hoisted_5, _hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
      class: "btn left",
      onClick: _cache[1] || (_cache[1] = (...args) => $options.close && $options.close(...args))
    }, "不取消"), _createElementVNode("strong", {
      class: "btn right",
      onClick: _cache[2] || (_cache[2] = (...args) => $options.cancelFavor && $options.cancelFavor(...args))
    }, "取消看好")])], 64)) : _createCommentVNode("", true), $props.type == 'cancelSuccess' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 2
    }, [_hoisted_8, _hoisted_9, _createElementVNode("strong", {
      class: "btn",
      onClick: _cache[3] || (_cache[3] = (...args) => $options.close && $options.close(...args))
    }, "知道了")], 64)) : _createCommentVNode("", true)])]),
    _: 1
  }, 8, ["show"]);
}